'use client';

import { useMemo } from 'react';
import DOMPurify from 'isomorphic-dompurify';
import parse from 'html-react-parser';

type BannerFields = {
    html?: string;
    startDate?: string;
    endDate?: string;
};

export default function PromotionBannerClient({ fields }: { fields: BannerFields }) {
    const isActive = useMemo(() => {
        if (!fields.html || !fields.startDate || !fields.endDate) {
            return false;
        }
        const now = new Date();
        return now >= new Date(fields.startDate) && now <= new Date(fields.endDate);
    }, [fields]);

    const sanitizedHtml = useMemo(() => {
        if (!isActive || !fields.html) return null;
        const clean = DOMPurify.sanitize(fields.html, {
            WHOLE_DOCUMENT: false,
            ADD_ATTR: ['target', 'rel', 'border'],
        });
        return parse(clean);
    }, [isActive, fields.html]);

    if (!isActive || !sanitizedHtml) {
        return null;
    }

    return (
        <div className="promotion-banner">
            {sanitizedHtml}
        </div>
    );
}
